import React, {useEffect} from 'react';
import {observer} from 'mobx-react-lite'
import Btn from '../../../ui/Btn'
import clubStore from '../../../storage/ClubStore'
import appStore from '../../../storage/AppStore'

const MemberModal = () => {
  const [selectedMembers, setSelectedMembers] = React.useState([]);
  
  const toggleSelectedMember = (member_id, checked) => {
    if (!checked) {
      setSelectedMembers(selectedMembers.filter(m => m.id!== member_id));
    } else {
      setSelectedMembers([...selectedMembers, member_id]);
    }
  }
  
  const toggleAllMembers = (isAll) => {
    if (isAll) {
      setSelectedMembers(clubStore.freeMembers.map(m => m.id));
    } else {
      setSelectedMembers([]);
    }
  }
  
  useEffect(() => {
    clubStore.getFreeMembers();
  }, [clubStore.club.id, clubStore.team.id]);
  return (
    <>
      <Btn className={"btn btn-sm btn-success"} data-bs-toggle="modal" data-bs-target="#modalId">
        <i className="ci ci-user-plus"/>
      </Btn>
      <div className="modal fade" id="modalId" tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-dialog-scrollable" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{appStore.tr.add_member}</h5>
              <button className="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close"/>
            </div>
            <div className="modal-body">
              <div className="table-responsive">
                <table className="table table-striped">
                  <thead>
                  <tr>
                    <th>
                      {clubStore.freeMembers.length > 0 &&
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="ex-check-all"
                            onChange={(e) => toggleAllMembers(e.target.checked)}
                            checked={selectedMembers.length === clubStore.freeMembers.length}
                          />
                          <label htmlFor="ex-check-all" className="form-check-label">&nbsp;</label>
                        </div>
                      }
                    </th>
                    <th>{appStore.tr.title}</th>
                    <th>
                      {selectedMembers.length > 0 &&
                        <Btn
                          className={"btn btn-sm btn-primary"}
                          onClick={() => clubStore.addTeamMembers(selectedMembers).then(() => {
                            clubStore.getTeam(clubStore.team.id);
                            setSelectedMembers([]);
                          })}>
                          <i className="ci ci-user-check"/>
                        </Btn>
                      }
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  {clubStore.freeMembers.map((member, index) => (
                    <tr key={index}>
                      <td>
                        <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={`ex-check-${index}`}
                          onChange={(e) => toggleSelectedMember(member.id, e.target.checked)}
                          checked={selectedMembers.some((m) => m === member.id)}
                        />
                          <label htmlFor="ex-check-1" className="form-check-label">&nbsp;</label>
                      </div>
                      </td>
                      <td>{member.role_id === 'TRN' ? <b>{member.title}</b> : <span>{member.title} #{member.forma_number} ({member.year_born})</span>}</td>
                      <td>
                        <Btn
                          className={"btn btn-sm btn-success"}
                          onClick={() => clubStore.addTeamMembers([member.id]).then(()=>{
                            clubStore.getTeam(clubStore.team.id);
                            setSelectedMembers([]);
                          })}>
                          <i className="ci ci-user-check"/>
                        </Btn>
                      </td>
                    </tr>
                  ))}
                  </tbody>
                </table>
              </div>
            </div>
          
          </div>
        </div>
      </div>
    </>
  );
}

export default observer(MemberModal);